import React, { useEffect, useState } from "react";
import "./notFoundWebhook.css";
import {
  getNotFoundWebhooks,
  paidNotFoundWebhooks,
} from "../../../config/LiveApi";
import Pagination from "../pagination";
import { toast } from "react-toastify";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import { IoMdCopy } from "react-icons/io";
import { FcApprove } from "react-icons/fc";

const RawWebhookPage = () => {
  const [statusData, setStatusData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedRows, setExpandedRows] = useState(new Set());

  const fetchRawWebhookData = async (currentPage, searchTerm) => {
    try {
      setLoading(true);
      const response = await getNotFoundWebhooks(currentPage, "", searchTerm);
      setStatusData(response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Unable to fetch status.");
    }
  };

  const handleAction = async (id) => {
    try {
      await paidNotFoundWebhooks(id);
      setStatusData((prevData) =>
        prevData.map((entry) => {
          if (entry.notFoundWebhook._id === id) {
            return {
              ...entry,
              notFoundWebhook: {
                ...entry.notFoundWebhook,
                paid: true,
              },
            };
          }
          return entry;
        })
      );
      toast.success("Marked as Paid");
    } catch (err) {
      toast.error("Failed to update status");
    }
  };

  const toggleRow = (key) => {
    setExpandedRows((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(key)) {
        newSet.delete(key);
      } else {
        newSet.add(key);
      }
      return newSet;
    });
  };

  useEffect(() => {
    if (searchTerm !== "") {
      const delayDebounce = setTimeout(() => {
        fetchRawWebhookData(1, searchTerm);
      }, 1000);
      return () => clearTimeout(delayDebounce);
    }
  }, [searchTerm]);

  useEffect(() => {
    if (searchTerm === "") {
      fetchRawWebhookData(currentPage, "");
    }
  }, [currentPage, searchTerm]);

  const handleCopy = (data) => {
    const text = JSON.stringify(data, null, 2);
    navigator.clipboard
      .writeText(text)
      .then(() => {
        alert("Response Copied!");
      })
      .catch((err) => {
        console.error("Copy failed", err);
      });
  };

  return (
    <div className="raw-webhook-table-container">
      <div className="raw-webhook-heading">
        <h2 className="raw-webhook-table-title">Not Found Webhooks</h2>
        <input
          className="webhook-input-field-container"
          type="text"
          placeholder="Search by UTR ID"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <table className="webhook-table">
        <thead>
          <tr>
            <th>OrderId</th>
            <th>UTR Id</th>
            <th>Amount</th>
            <th>VPA</th>
            <th>Status</th>
            <th>Date</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="6">Loading...</td>
            </tr>
          ) : statusData?.length > 0 ? (
            statusData.map((entry) => {
              const item = entry.notFoundWebhook;
              const rowKey = `${item.orderId}-${item.utr}`;

              return (
                <React.Fragment key={rowKey}>
                  <tr>
                    <td>{item?.orderId || "N/A"}</td>
                    <td>{item?.utr || "N/A"}</td>
                    <td>{item?.incomingWebhook?.AMOUNT || "N/A"}</td>
                    <td>{item?.incomingWebhook?.vpa || "N/A"}</td>
                    <td>
                      {item?.paid ? (
                        <span className="paid-label">Paid</span>
                      ) : (
                        <button
                          className="approve-btn"
                          onClick={() => handleAction(item._id)}
                        >
                          <FcApprove size={22} />
                        </button>
                      )}
                    </td>

                    <td>
                      {new Date(item?.updatedAt).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: false,
                      })}
                    </td>
                    <td
                      onClick={() => toggleRow(rowKey)}
                      style={{ cursor: "pointer" }}
                    >
                      {expandedRows.has(rowKey) ? (
                        <FaCaretUp />
                      ) : (
                        <FaCaretDown />
                      )}
                    </td>
                  </tr>

                  {expandedRows.has(rowKey) && (
                    <tr>
                      <td colSpan="7">
                        <div className="flex-column">
                          <div
                            className="group-item"
                            style={{
                              marginBottom: "16px",
                              paddingBottom: "16px",
                              borderBottom: "2px solid black",
                            }}
                          >
                            <div className="details-grid">
                              <div className="more-details">
                                <p className="json-card">OrderId :</p>
                                <p>{item.orderId}</p>
                              </div>
                              <div className="more-details">
                                <p className="json-card">UTR Id :</p>
                                <p>{item.utr}</p>
                              </div>
                              <div className="more-details">
                                <p className="json-card">Date :</p>
                                <p>
                                  {new Date(item?.updatedAt).toLocaleString(
                                    "en-GB",
                                    {
                                      day: "2-digit",
                                      month: "2-digit",
                                      year: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      second: "2-digit",
                                      hour12: false,
                                    }
                                  )}
                                </p>
                              </div>
                              <div className="more-details">
                                <p className="json-card">Status :</p>
                                <p className="color">
                                  {item?.incomingWebhook?.RESPONSE_STATUS ||
                                    "N/A"}
                                </p>
                              </div>
                            </div>

                            <div className="flex-column">
                              <div className="more-details">
                                <div className="copy-container">
                                  <p className="json-card">
                                    Incoming Webhook :
                                  </p>
                                  <p
                                    className="json-card"
                                    onClick={() =>
                                      handleCopy(item?.incomingWebhook)
                                    }
                                  >
                                    <IoMdCopy size={20} />
                                  </p>
                                </div>
                                <span>
                                  {JSON.stringify(
                                    item?.incomingWebhook,
                                    null,
                                    2
                                  )}
                                </span>
                              </div>

                              <div className="more-details">
                                <div className="copy-container">
                                  <p className="json-card">Raw Webhook :</p>
                                  <p
                                    className="json-card"
                                    onClick={() =>
                                      handleCopy(entry?.matchedRawWebhooks)
                                    }
                                  >
                                    <IoMdCopy size={20} />
                                  </p>
                                </div>
                                <span>
                                  {JSON.stringify(
                                    entry?.matchedRawWebhooks,
                                    null,
                                    2
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })
          ) : (
            <tr>
              <td colSpan="7">No data found.</td>
            </tr>
          )}
        </tbody>
      </table>
      <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} />
    </div>
  );
};

export default RawWebhookPage;
